import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { CorrectionModule } from './correction.module';
platformBrowserDynamic().bootstrapModule(CorrectionModule);
